var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDislikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4661_32173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#949494"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4661_32173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22438 3.25342H13.4775V13.2532L7.94875 18.7501L7.24375 18.0449C7.15708 17.9584 7.08521 17.8438 7.02812 17.7011C6.9709 17.5585 6.94229 17.4242 6.94229 17.2982V17.0865L7.82708 13.2532H2.75646C2.36007 13.2532 2.00993 13.1013 1.70604 12.7974C1.40201 12.4933 1.25 12.1432 1.25 11.747V10.4007C1.25 10.3142 1.2591 10.2207 1.27729 10.1203C1.29549 10.0199 1.32271 9.9264 1.35896 9.83988L3.74688 4.20529C3.86646 3.93821 4.06674 3.71279 4.34771 3.52904C4.62868 3.34529 4.9209 3.25342 5.22438 3.25342ZM14.7275 13.2532V3.25342H17.9167V13.2532H14.7275Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDislikeIcon);
export default __webpack_public_path__ + "static/media/active-dislike-icon.63fb1b9bb0f6398ad41607ae4d84cec3.svg";
export { ForwardRef as ReactComponent };